enum COURSE_ROLES {
  ROLE_USER = 'ROLE_USER',
  ROLE_LECTURER = 'ROLE_LECTURER',
  ROLE_MENTOR = 'ROLE_MENTOR',
  ROLE_CS = 'ROLE_CS',
}

export default COURSE_ROLES;
